import { styled } from 'styled-components';
import Button from 'react-bootstrap/Button';

// No Auth pages
export const NoAuthFormContainer = styled.div`
    background-color: #f5f7fa;
    margin: 0 auto;
    width: 55%;

    form {
        display: grid;

        > label {
            font-size: 15px;
            font-weight: bold;
        }

        > span {
            color: #d04437;
            font-size: 13px;
            min-height: 12px;
        }

        > button {
            background-color: #d04437;
        }
    }
`;

// Cruds
export const AddButton = styled.button`
    align-items: center;
    background-color: #a5a7a0;
    border-color: #a5a7a0;
    display: flex;

    &:hover {
        background-color: #a5a7a0;
        border-color: #a5a7a0;
    }

    svg {
        font-size: 18px;
        margin-right: 6px;
    }
`;

export const TableHeaderContainer = styled.div`
    align-items: center;
    display: flex;
    margin-top: 30px;

    > p {
        font-size: 15px;
        margin-bottom: 0;
        margin-left: 5px;
    }

    > button {
        align-items: center;
        border: 1px solid #a5a7a0;
        display: flex;

        &:hover {
            border: 1px solid #a5a7a0;
        }

        > svg {
            font-size: 18px;
            margin-right: 8px;
        }
    }
`;

export const TableActionButton = styled.button`
    align-items: center;
    display: flex;
    font-size: 12px;
    justify-content: center;
    margin-right: 8px;
    min-width: fit-content;
    padding: 4px 8px;

    &.edit {
        background-color: #a5a7a0;
        border-color: #a5a7a0;
    }

    svg {
        color: #ffffff;
        font-size: 16px;
        margin-right: 2px;
    }

    > a {
        color: #ffffff;
        text-decoration: none;
    }
`;

// Common
export const ToggleOption = styled.div`
    &&& {
        > label {
            background-color: white;
            border-color: #d04437;
            color: #d04437;

            &:hover,
            &:focus,
            &:active {
                background-color: white;
                border-color: #d04437;
                color: #d04437;
            }
        }

        .btn-check:checked + label {
            background-color: #d04437;
            border-color: #d04437;
            color: white;

            &:hover,
            &:focus,
            &:active {
                background-color: #d04437;
                border-color: #d04437;
                color: white;
            }
        }

        .first-option {
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
        }

        .second-option {
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }

        .disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
`;

export const ModalButton = styled(Button)`
    border: none;

    &.cancel {
        background-color: #a5a7a0;
    }

    &.action {
        background-color: #d04437;
    }
`;

export const OrderStatusLegend = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
    margin-right: 8px;
`;
